import { Button, PageHeader } from '@berky/ui'
import { Link, useLocation } from 'react-router'

/** Adresse existiert nicht. */
export function NotFoundPage() {
  const location = useLocation()

  return (
    <div className="max-w-2xl">
      <PageHeader
        title="Diese Seite gibt es nicht"
        description="Möglicherweise ist der Link veraltet oder die Anwendung wurde umbenannt."
      />
      <p className="text-sm text-muted-foreground">
        Aufgerufene Adresse: <code className="font-mono">{location.pathname}</code>
      </p>
      <Button asChild className="mt-6">
        <Link to="/">Zur Startseite</Link>
      </Button>
    </div>
  )
}
